var map = {
	"./icon-1.png": 843,
	"./icon-2.png": 844,
	"./icon-3.png": 845,
	"./icon-4.png": 846,
	"./icon-5.png": 847,
	"./icon-6.png": 848,
	"./mainlogo.png": 345
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 842;